import React from "react";

import { usePlaceTagsOptions } from "api/hooks";
import { PlaceForm, PlaceFormValues } from "./PlaceForm/PlaceForm";
import { useNavigate } from "react-router-dom";
import { placesApi } from "api";
import { routes } from "consts";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { getApiErrorMessage, useToaster } from "utils";
import { PageMain } from "components/molecules";

export const PlaceAddPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const { loading, options: tags } = usePlaceTagsOptions();

  if (loading) return null;

  const onSubmit = async (data: PlaceFormValues) => {
    try {
      await placesApi.create(data);
      navigate(routes.PLACES);
      showSuccess("Dodano nowe miejsce");
    } catch (error) {
      showError(getApiErrorMessage(error, "Nie udało się dodać miejsca"));
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Miejsca", path: routes.PLACES }, { title: "Tworzenie nowego miejsca" }]}
        headerText="Dodaj nowe miejsce"
      />
      <PlaceForm tags={tags} onSubmit={onSubmit} />
    </PageMain>
  );
};
